import Storage from 'vue-ls'
const jwt = require('jsonwebtoken')

const options = {
  namespace: 'mf-',
  name: 'ls',
  storage: 'session',
}

const { ls } = Storage.useStorage(options)

export const setData = (key, data, isEncrypted) => {
  if (isEncrypted) {
    ls.set(key, jwt.sign({ data }, process.env.VUE_APP_JWT_KEY))
  } else {
    ls.set(key, JSON.stringify(data))
  }
}

export const getData = (key, defaultData = '', isEncrypted) => {
  let data = ls.get(key, defaultData)
  if (isEncrypted) {
    data = jwt.verify(data, process.env.VUE_APP_JWT_KEY)
    return data
  }
  return data ? JSON.parse(data) : defaultData
}

export const removeData = (key) => {
  ls.remove(key)
}
